// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"a623d078","301":"494d4155","346":"32b52101","798":"cccc4324","967":"7bb02684"}[chunkId] + ".css";
};